import { scData } from '../tracking-constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const scCheckout = (data: any) => ({
  event: 'scCheckout',
  timestamp: Math.floor(Date.now() / 1000),
  ecommerce: scData(data),
});
